import * as Cookies from 'js-cookie';

class CookieHandler {
  public get(name: string): string {
    return Cookies.get(name) || '';
  }

  public set(name: string, value: string): void {
    Cookies.set(name, value);
  }
}

export default CookieHandler;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/infrastructure/adapter/CookieHandler.ts